export const formatEmail = (allData) => {
  const {
    data,
    guardrailGroups = [],
    floorGroups = [],
    stairsGroups = [],
    wallGroups = [],
    baseboardGroups = [],
    poolGroups = [],
    ceilingGroups = [],
  } = allData;

  const defaultLine = (label, arr, field) => {
    const value = arr[field];
    if (!value || value === "" || value.length === 0) return "";
    const extraPath = `${field}Extra`;
    const extra = arr[extraPath];
    const obsField = `${field}Obs`;
    const obsValue = arr[obsField];
    const res = typeof value === "string" ? value : value.join(", ");
    let line = `${label}: ${res.toLowerCase().includes("outro") ? `${res} - ${extra}` : res}`;
    if (obsValue && obsValue !== "") line += `\nObservações: ${obsValue}`;
    return line;
  };

  const thicknessLine = (label, arr, extra) => {
    let res = [];
    arr.forEach(element => {
      if (element.thickness && element.thickness > 0) {
        res.push(`${element.type} (${element.thickness} cm)`);
      } else if (element.type === "Outro") {
        res.push(`Outro - ${extra}`);
      } else {
        res.push(element.type);
      }
    });
    if (!res || res.length === 0) return "";
    return `${label}: ${res.join(", ")}`;
  };

  let text = "";

  text += "Telhado\n";
  text += defaultLine("Tipo de telhado", data, "roofType") + "\n";
  text += defaultLine("Estrutura de telhado", data, "roofStructure") + "\n";
  text += defaultLine("Tipo de calha", data, "roofGutter") + "\n\n";

  text += "Molduras\n";
  text += defaultLine("Material das Molduras", data, "frameType") + "\n";
  if (data.extraFrame !== "") text += defaultLine("Material extra", data, "extraFrame") + "\n";
  text += "\n";

  text += "Peitoris\n";
  text += defaultLine("Estrutura", data, "sill") + "\n";
  if (data.extraFrame !== "") text += defaultLine("Material extra", data, "extraSill") + "\n";
  text += "\n";

  text += "Pergolado\n";
  text += defaultLine("Estrutura", data, "pergola") + "\n";
  if (data?.pergola?.toLowerCase().includes("concreto")) text += defaultLine("Acabamento igual do ambiente", data, "extraFrame") + "\n";
  text += "\n";

  text += "Vagas\n";
  text += defaultLine("Estrutura", data, "parking") + "\n";
  text += defaultLine("Material", data, "parkingMat") + "\n\n";

  text += "Rufos\n";
  text += defaultLine("Onde considerar rufos", data, "flashing") + "\n";
  if (data?.flashing?.includes("Muros acima de altura X")) text += defaultLine("Muros acima de (CM):", data, "flashingHeight") + "\n";
  text += defaultLine("Material", data, "flashingMats") + "\n\n";

  text += "Soleiras\n";
  text += defaultLine("Portas com soleira", data, "thresholdLocs") + "\n";
  text += defaultLine("Material", data, "thresholdMats") + "\n\n";

  text += "Piscina\n";
  poolGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += defaultLine("Estrutura", group, "structure") + "\n";
    text += defaultLine("Acabamento superior", group, "upperFinish") + "\n";
    text += defaultLine("Acabamento Externo", group, "externalFinish") + "\n\n";
  });

  text += "Guarda-corpos\n";
  guardrailGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += defaultLine("Tipo de guarda-corpo", group, "type") + "\n\n";
  });

  text += "Escadas\n";
  stairsGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += defaultLine("Estrutura", group, "structure") + "\n";
    text += thicknessLine("Pré-acabamento dos pisos", group.preFinish || [], group.preFinishExtra) + "\n";
    text += defaultLine("Acabamento dos pisos", group, "finish") + "\n";
    text += thicknessLine("Pré-acabamento do teto", group.roofPrefinish || [], group.roofPrefinishExtra) + "\n";
    text += defaultLine("Acabamento do teto", group, "roofFinish") + "\n";
    if (group?.roofFinish?.toLowerCase() === "pintura" || group?.roofFinish?.toLowerCase() === "textura branca + pintura" || group?.roofFinish?.toLowerCase() === "textura pigmentada")
      text += defaultLine("Cor/Código do Acabamento do teto", group, "roofFinishColor") + "\n";
    text += defaultLine("Corrimões", group, "handrail") + "\n\n";
  });

  text += "Pisos\n";
  floorGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += thicknessLine("Pré-acabamentos", group.preFinish || [], group.preFinishExtra) + "\n";
    text += defaultLine("Acabamento", group, "finish") + "\n\n";
  });

  text += "Tetos\n";
  ceilingGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += thicknessLine("Pré-acabamentos", group.preFinish || [], group.preFinishExtra) + "\n";
    text += defaultLine("Acabamento", group, "finish") + "\n\n";
  });

  text += "Paredes\n";
  wallGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += thicknessLine("Pré-acabamentos", group.preFinish || [], group.preFinishExtra) + "\n";
    text += defaultLine("Acabamento", group, "finish") + "\n";
    if (group.hidrWallFinish !== "") text += defaultLine("Acabamento de paredes hidráulicas", group, "hidrWallFinish") + "\n";
    if (group.isPillarDiff === "Sim") text += defaultLine("Pré-acabamento de pilares e vigas", group, "pillarDiff") + "\n";
    text += "\n";
  });

  text += "Rodapés\n";
  baseboardGroups.forEach((group, idx) => {
    text += `Grupo ${idx + 1}\n`;
    text += `Ambientes: ${group.rooms.join(", ")}\n`;
    text += defaultLine("Tipo", group, "type") + "\n";
    text += defaultLine("Altura", group, "height") + "\n\n";
  });

  return text.trim();
};